// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__3g5sh","switch":"Switch_switch__2H8IP","slider":"Switch_slider__1dVO0","label":"Switch_label__1E73b"};